import { Dauer, terminart, ThemaFromThemaRouter } from '../../../dtos.ts';
import { PlanningData } from './planningData.types.ts';

export const initializePlanningData = (thema: Pick<ThemaFromThemaRouter, 'module'>): PlanningData => ({
  terminart: terminart.STANDARD,
  module: thema.module.map((modul): PlanningData['module'][number] => {
    const dauerDays = getDauerDays(modul.dauer);
    return {
      modulnummer: modul.modulnummer,
      gruppenraumInfo: modul.gruppenraumInfo,
      datum: null,
      termine: Array.from({ length: dauerDays }).map(() => ({
        uhrzeiten: {
          start: null,
          end: null,
        },
        expertenSapIds: [],
      })),
    };
  }),
});

export const allRequiredFieldsDefined = (data: PlanningData): boolean => {
  for (const modul of data.module) {
    if (!modul.datum) {
      return false;
    }
    for (const termin of modul.termine) {
      if (!termin.uhrzeiten.start || !termin.uhrzeiten.end) {
        return false;
      }
    }
  }
  return true;
};

export const getDauerDays = (dauer: Dauer | null): number => {
  if (!dauer) {
    return 0;
  }
  const dayAmount = dauer.days ?? 0;
  const hoursInDaysAmount = (dauer.hours ?? 0) / 24;
  const minutesInDaysAmount = (dauer.minutes ?? 0) / (24 * 60);
  return Math.ceil(dayAmount + hoursInDaysAmount + minutesInDaysAmount);
};
